import { render, staticRenderFns } from "./VehicleAdd.vue?vue&type=template&id=6c4a6550&"
import script from "./VehicleAdd.vue?vue&type=script&lang=js&"
export * from "./VehicleAdd.vue?vue&type=script&lang=js&"
import style0 from "./VehicleAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports